module.exports = __webpack_public_path__ + "assets/fonts/iconfont.64d79301.woff";